export const FIX_LOCATION_CATEGORY_IDS = [
  'e4cdaacb-d24d-4ce4-a3cc-8f3023cf7f5a',
  '019f080e-29a3-4ce6-9918-13de139792b4',
  'a7606e7e-be1a-455c-979e-7c43236c73e1',
  'f5a51a9f-9520-4fc6-83d2-6ebac3c5cc36',
  '2c957e9a-5868-46d6-a90a-5975222604aa',
  '78026daf-d772-434d-a601-9f5c05c26b5b',
];
